import React from "react";
import { DropdownMenuLabel, DropdownMenuSeparator } from "../ui/dropdown-menu";
import { DropdownMenuItem } from "@radix-ui/react-dropdown-menu";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { ScrollArea } from "../ui/scroll-area";

const NotificationDropdown = () => {
  const lowStockItems = [
    { id: 1, name: "B4 65mm Brush", stock: 5, badge: "Restock by May 17" },
    { id: 2, name: "B5 80mm Brush", stock: 2, badge: "Restock by May 18" },
    { id: 6, name: "Curl Defining Cream", stock: 0, badge: "Restock by May 20" },
  ];

  const specialDeals = [
    { id: 1, name: "B4 65mm Brush", discount: 20, badge: "Until May 14" },
    { id: 6, name: "Curl Defining Cream", discount: 15, badge: "Until May 18" },
  ];
  return (
    <>
      <DropdownMenuLabel className="px-4 py-3 font-medium text-lg">Notifications</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <ScrollArea className="h-72  ">
        <div className="max-w-4xl pr-3 pb-2">

      <div className="pl-1 pb-1">
      {/* <h4 className="text-sm font-medium text-palette-text px-2 pt-2">Low Stock Items</h4> */}


   
       <DropdownMenuItem
        asChild
        className="cursor-pointer hover:outline-none focus:outline-none  p-2  rounded-md  w-full ">
           <p className="text-xs text-palette-text mt-1">

          No Notifications yet
           </p>
        </DropdownMenuItem>
    
     
{/* 
      {lowStockItems.map((item) => (
        <DropdownMenuItem
          asChild
          key={item.id}
          className="cursor-pointer hover:outline-none focus:outline-none  p-2  rounded-md  "
        >
          <div className="flex justify-between gap-4 items-start">
            <div className="">
              <p className="text-xs font-medium">{item.name}</p>
              <p className="text-xs text-palette-text mt-1">
                {item.stock > 0 ? `Only ${item.stock} left in stock` : "Out of stock"}
              </p>
            </div>
            <Badge className="text-xs bg-red-500 text-white hover:bg-red-400">{item.badge}</Badge>
          </div>
        </DropdownMenuItem>
      ))} */}
      {/* <Link to="/quick-reorder">
        <Button className="w-full bg-black hover:bg-gray-800 text-white mt-3">
          <Zap className="mr-2 w-4 h-4" />
          Quick Reorder All
        </Button>
      </Link> */}
      </div>
      {/* <DropdownMenuSeparator /> */}
      <div className="pl-1 ">
      
      {/* <h4 className="text-sm font-medium text-palette-text px-2 pt-2">Special Deals</h4> */}
      {/* {specialDeals.map((item) => (
        <DropdownMenuItem
          asChild
          key={item.id}
          className="cursor-pointer hover:outline-none focus:outline-none  p-2  rounded-md  "
        >
          <div className="flex justify-between gap-4 items-start">
            <div className="">
              <p className="text-xs font-medium">{item.name}</p>
              <p className="text-xs text-palette-text mt-1">
                {item.discount > 0 ? `Discount: ${item.discount}%` : "No discount available"}
              </p>
            </div>
            <Badge className="text-xs bg-red-500 text-white hover:bg-red-400">{item.badge}</Badge>
          </div>
        </DropdownMenuItem>
      ))} */}
      {/* <Link to="/quick-reorder">
        <Button className="w-full  hover:bg-gray-800 hover:text-white border border-gray-300 mt-3">View ALl Deals</Button>
      </Link> */}
      </div>
      </div>
      </ScrollArea>
    </>
  );
};

export default NotificationDropdown;
